import React from 'react';
import styles from '../styles/button.module.scss';

const Button = ({ children, buttonType, onClick }) => {
  return (
    <button className={styles.button} type={buttonType} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
